
import React from "react"
import PropTypes from "prop-types"
import { Button } from "reactstrap"
import { LazyLoadImage } from "react-lazy-load-image-component"
import Icon from "./Icon"
import { FilePdfOutlined } from "@ant-design/icons"
import { useDispatch, useSelector } from "react-redux"
import { setActiveSlide } from "store/lightbox"
import styles from "components/layout/style.module.css"

function getFileExtension(url) {
  try {
    const pathname = new URL(url).pathname
    const lastSegment = pathname.split("/").pop()
    const extension = lastSegment?.split(".").pop()
    return extension || null
  } catch (error) {
    console.error("Invalid URL", error)
    return null
  }
}

PreviewMedia.propTypes = {
  preview: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  ratio: PropTypes.string,
  type: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  className: PropTypes.string,
  mediaClassName: PropTypes.string,
  actions: PropTypes.node,
  onClose: PropTypes.func,
  rounded: PropTypes.bool,
  fluid: PropTypes.bool,
  imageHeight: PropTypes.number
}

export default function PreviewMedia({
  preview,
  placeholder,
  ratio = "",
  type,
  index,
  className = "",
  mediaClassName = "",
  actions,
  onClose,
  rounded = true,
  fluid = false,
  imageHeight = 140
}) {
  const dispatch = useDispatch()
  const slides = useSelector((store) => store.lightbox.slides)

  const clickHandler = () => slides?.length && dispatch(setActiveSlide(index))

  const classes = ["position-relative"]
  if (className) classes.push(className)

  const buttonClasses = ["p-0 rounded", styles.pdfExpenseUpload]
  if (fluid || ratio) buttonClasses.push("w-100")
  else buttonClasses.push("w-auto")
  if (ratio) buttonClasses.push(`ratio ratio-${ratio}`)

  const imageClasses = ["object-fit-cover h-100 w-100"]
  if (rounded) imageClasses.push("rounded")
  if (!fluid && !ratio) imageClasses.push("w-auto")
  if (mediaClassName) imageClasses.push(mediaClassName)

  const mediaClasses = ["object-fit-cover h-100 w-100", rounded && "rounded", !fluid && !ratio && "w-auto", mediaClassName]
    .filter(Boolean)
    .join(" ")

  const fileExtension = getFileExtension(preview)

  let mediaContent

  if (type === "application" || fileExtension === "pdf") {
    mediaContent = (
      <div>
        <FilePdfOutlined style={{ width: 40, height: 80, fontSize: 60, color: "red" }} />
      </div>
    )
  } else if (fileExtension === "video" || type === "video") {
    mediaContent = (
      <div className="position-relative w-100" style={{ height: "140px" }}>
        <video src={preview} className={mediaClasses} style={{ height: imageHeight }} controls={false} preload="metadata" muted />
        <Icon iconName="Play" className="position-absolute top-50 start-50 translate-middle text-white" width={30} height={30} />
      </div>
    )
  } else {
    mediaContent = (
      <LazyLoadImage
        src={preview}
        height={imageHeight}
        className={imageClasses.join(" ")}
        alt=""
        placeholderSrc={placeholder}
        effect="blur"
      />
    )
  }

  return (
    <div className={classes.join(" ")}> 
      {actions && (
        <div
          className={`position-absolute top-0 end-0 p-2 hstack gap-10 ${onClose ? "pe-15" : ""}`}
          style={{ zIndex: 1 }}
        >
          {actions}
        </div>
      )}
      {onClose && (
        <Button
          color="ghost"
          size="icon"
          className="position-absolute  top-0 end-0 z-1 m-n1 p-0 text-white shadow bg-transparent-hover"
          onClick={onClose}
        >
          <Icon iconName="CloseFill" width={20} height={20} />
        </Button>
      )}

      <Button type="button" color="ghost" className={buttonClasses.join(" ")} onClick={clickHandler}>
        {mediaContent}
      </Button>
    </div>
  )
}
